var React = require('react');

function PostShare (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13 2L22 11L13 19.5V14C6 14 3 21.5 3 21.5C3 13 5.5 7.5 13 7.5V2Z","stroke":"#303030","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

PostShare.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = PostShare;

PostShare.default = PostShare;
